import { intersectionBy } from 'lodash';
import { AppThunk } from '../../../store/rootReducer';
import { ecgIdSelector } from '../../ecg/selectors/ecg.selectors';
import * as diagnosticActions from '../actions/diagnostic.actions';
import * as diagnosticsClient from '../clients/diagnostic.client';
import {
  allAbnormalitiesSelector,
  editableDiagnosticSelector,
  suggestionsLogsSelector,
} from '../selectors/user-diagnostic.selectors';
import {
  EMPTY_COMMENT,
  ServerAnnotatorComment,
  ServerAutoLabelsLogs,
} from '../types/diagnostic';
import { isDiagnosticEmpty } from '../utils/diagnostic.util';
import { displayNotification } from '../../../shared/notification/display-notification';
import { getLayoutValueSelector } from '../../layout/selectors/layout.selectors';
import { getMetricsSelector } from '../../metric/selectors/metric.selectors';

export const saveDiagnostic = (): AppThunk => async (dispatch, getState) => {
  let diagnostic = editableDiagnosticSelector(getState());
  const abnormalities = allAbnormalitiesSelector(getState());
  const ecgId = ecgIdSelector(getState());
  const withComputedMetrics = getLayoutValueSelector('withComputedMetrics')(
    getState(),
  );

  const withSuggestionsPanel = getLayoutValueSelector('withSuggestionsPanel')(
    getState(),
  );

  if (ecgId == null) {
    return;
  }

  // some of the abnormalities may not exist in the user's annotation table
  // so we filter here
  const parsedAbnormalities = intersectionBy(
    diagnostic.abnormalities,
    abnormalities,
    'code',
  );

  // Add a '--' on comment if the diagnostic is completely empty
  if (isDiagnosticEmpty(diagnostic)) {
    diagnostic = { ...diagnostic, comment: EMPTY_COMMENT };
  }

  const annotatorComment: ServerAnnotatorComment = {};
  if (withSuggestionsPanel) {
    const suggestionsLogs = suggestionsLogsSelector(getState()) as Record<
      string,
      ServerAutoLabelsLogs
    >;
    annotatorComment['autoLabelsLogs'] = suggestionsLogs;
  }
  if (withComputedMetrics) {
    const metrics = getMetricsSelector(getState());
    annotatorComment['computedMetrics'] = metrics;
  }

  const success = await diagnosticsClient.saveDiagnostic(
    ecgId,
    diagnostic.comment,
    parsedAbnormalities,
    annotatorComment,
  );

  if (success) {
    dispatch(diagnosticActions.save({ diagnostic, meta: { history: false } }));
  } else {
    displayNotification({
      title: 'Error',
      description:
        'An error occurred, please try again or contact the support team',
      status: 'error',
    });
    return null;
  }
};
